var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.84 1.5H6.17c-2.84 0-3.54.76-3.54 3.78v8.45c0 1.99 1.09 2.46 2.42 1.04v-.01c.62-.65 1.56-.6 2.09.11l.76 1.02c.6.8 1.59.8 2.2 0l.75-1.02a1.32 1.32 0 0 1 2.1-.11c1.33 1.42 2.42.95 2.42-1.04V5.28c0-3.02-.7-3.78-3.53-3.78Zm-6 7.5a.75.75 0 0 1-.75-.75c0-.41.33-.75.75-.75.4 0 .75.34.75.75S6.25 9 5.83 9Zm0-3a.75.75 0 0 1-.75-.75c0-.41.33-.75.75-.75.4 0 .75.34.75.75S6.25 6 5.83 6Zm6.33 2.81H8.05a.57.57 0 0 1-.57-.56c0-.3.26-.56.57-.56h4.12c.31 0 .56.25.56.56 0 .3-.25.56-.56.56Zm0-3H8.05a.57.57 0 0 1-.57-.56c0-.3.26-.56.57-.56h4.12c.31 0 .56.25.56.56 0 .3-.25.56-.56.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingmedium);
export default __webpack_public_path__ + "static/media/billing.medium.4dc842f9eb6eeb426467e399e92a7fc7.svg";
export { ForwardRef as ReactComponent };